import { render, staticRenderFns } from "./NftCollectionVisibleToggleButton.vue?vue&type=template&id=96741b34"
import script from "./NftCollectionVisibleToggleButton.vue?vue&type=script&lang=ts"
export * from "./NftCollectionVisibleToggleButton.vue?vue&type=script&lang=ts"
import style0 from "./NftCollectionVisibleToggleButton.vue?vue&type=style&index=0&id=96741b34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports